import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import SlidePanel from "../add_customer/SlidePanel";

const LoadingPanel = ({ id, closeLoadingPanel, isLoadingPanelOpen }) => {
  const controlsFirst = useAnimation();
  const controlsSecond = useAnimation();
  const controlsThird = useAnimation();

  useEffect(() => {
    if (isLoadingPanelOpen) {
      controlsFirst.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0,
        },
      });

      controlsSecond.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0.2,
        },
      });

      controlsThird.start({
        y: [0, -10, 0],
        transition: {
          duration: 0.6,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
          delay: 0.4,
        },
      });
    } else {
      controlsFirst.stop();
      controlsSecond.stop();
      controlsThird.stop();
    }
  }, [isLoadingPanelOpen]);

  return (
    <SlidePanel isOpen={isLoadingPanelOpen} onClose={closeLoadingPanel}>
      <div className="flex items-center justify-center h-full bg-white px-6 rounded-[12px]">
        <div className="w-full max-w-md text-center">
          {/* Animated dots */}
          <div className="flex items-center justify-center mt-10 mb-8">
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsFirst}
            />
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsSecond}
            />
            <motion.div
              className="bg-black w-2 h-2 rounded-full mx-2"
              animate={controlsThird}
            />
          </div>

          {/* Text */}
          <div className="text-[#000] text-[15px] font-normal">
            <p>
              Reading the document to retrieve information. This might take a
              few seconds.
            </p>
          </div>
        </div>
      </div>
    </SlidePanel>
  );
};

export default LoadingPanel;
